import React from 'react';
import './index.scss';

export const displayNoValue = '--';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const NoData = () => (<div className="no-data-tag text-align-center">{displayNoValue}</div>);
